<template>
    <div v-if="puedeVerContadores" class="status-counter-container d-flex status-counters-flex">
      <v-card
        v-for="counter in counters"
        :key="counter.label"
        class="pa-2 d-flex align-center justify-space-between elevation-1 status-counter-border status-counter-flex-card"
        :style="`background: ${getCounterColor(counter.color)}; color: #fff;`"
      >
        <span class="font-weight-medium">{{ counter.label }}</span>
        <span class="font-weight-bold">{{ counter.value }}</span>
      </v-card>
    </div>
</template>


<script>
import http from "@/api/api.js";

export default {
  name: 'StatusCounters',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        Creado: 0,
        'En espera': 0,
        'En revisión': 0,
        Rechazado: 0,
        Aprobado: 0,
        Evaluadas: 0,
      }),
    },
  },
  data() {
    return {
      countersData: null, // Aquí guardamos la info del servidor
      loading: false,
      error: null,
    };
  },
  computed: {
    counters() {
      return this.countersData || this.getFallbackCounters();
    },
    role() {
      return this.$store.getters['Auth/role']
    },
    puedeVerContadores() {
      return this.role === 1 || this.role === 4 || this.role === 3
    }
  },
  mounted() {
    this.fetchCounters();
  },
  methods: {
    async fetchCounters() {
      this.loading = true;
      this.error = null;
      try {
        const data = { route: 'api/stats/', params: {} };
        const response = await http.post(data);
        if (response) {
          const counter =  response.data.data;
          this.countersData = [
            { label: 'Creadas', value: counter.Creadas, color: 'neon' },
            { label: 'Verificadas', value:  counter.Aprobadas || 0, color: 'teal' },
            { label: 'Rechazado', value:  counter.Rechazadas || 0, color: 'red' },
            { label: 'En revisión', value: counter.Revisadas || 0, color: 'purple darken-3' },
            // { label: 'Verificado', value:  counter.Verificadas || 0, color: 'primary' }
          ];

          if (this.role !== 3) {
            this.countersData.push({ label: 'Evaluado', value:  counter.Evaluadas || 0, color: 'pink' });
          }
          if (this.role === 1 || this.role === 4) {
            this.countersData.push({ label: 'Total', value: counter.Total || 0, color: 'primary' });
          }
        } else {
          this.error = 'Error fetching data counters';
          this.countersData = this.getFallbackCounters();
        }
      } catch (e) {
        this.error = e.message || 'Unknown error';
        this.countersData = this.getFallbackCounters();
      } finally {
        this.loading = false;
      }
    },
    getFallbackCounters() {
      const arrayLista = [
        { label: 'Creadas', value: this.data.Creadas || 0, color: 'teal' },
        { label: 'Rechazado', value: this.data.Rechazado || 0, color: 'red' },
        { label: 'Aprobado', value: this.data.Aprobado || 0, color: 'primary' },
        { label: 'En revisión', value: this.data.Revisadas || 0, color: 'purple darken-3' },
      ]

      if (this.role !== 3) {
        arrayLista.push({ label: 'Evaluado', value:  this.data.Evaluadas || 0, color: 'pink' });
      }

      if (this.role === 1) {
        arrayLista.push({ label: 'Total', value: this.data.Total || 0, color: 'primary' });
      }

      return arrayLista;
    },
    getCounterColor(color) {
      const colorMap = {
        'neon':           '#1ea3e5',
        'primary':        '#662D91',
        'teal':           '#009688',
        'red':            '#ff1807',
        'warning':        '#e29928',
        'purple darken-3':'#6d46cc',
        'black':          '#2a282f',
        'pink':           '#d8602f',
      };
      return colorMap[color] || color;
    }
  },
};

</script>

<style scoped>
.status-counter-container {
  padding: 24px 16px 0 16px !important;
  margin-bottom: 0 !important;
  background: rgba(255, 255, 255, 0) !important;
}

.status-counters-flex {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  justify-content: center;
}

.status-counter-flex-card {
  flex: 1 1 180px;
  margin: 0 !important;
  min-width: 120px;
  max-width: 220px;
  border-radius: 12px;
  border: none !important;
  color: #fff !important;
  transition: box-shadow 0.2s;
}

@media (max-width: 900px) {
  .status-counter-flex-card {
    min-width: 100px;
    max-width: 160px;
    font-size: 0.95rem;
    padding: 8px !important;
  }
}

@media (max-width: 600px) {
  .status-counters-flex {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }
  .status-counter-flex-card {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    font-size: 0.9rem;
    padding: 8px 6px !important;
  }
  .status-counter-container {
    padding: 12px 4px 0 4px !important;
  }
}
</style>

<style scoped>
/*
.status-counter-container {
    padding: 24px 32px 0 32px !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    background: rgba(255, 255, 255, 0) !important;
}

.status-counters-flex {
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  justify-content: center;
}

.status-counter-flex-card {
  flex: 1 1 180px;
  margin: 0 !important;
  min-width: 120px;
  max-width: 220px;
  border-radius: 12px;
}

.status-counter-container.v-row {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.compact-counters > .v-col {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.compact-counters {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.no-bottom-space {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.status-counter-container > .v-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
  */
</style>
